export const DateInterval = {
    Year: 'Year',
    Month: 'Month',
    Quarter: 'Quarter',
    Week: 'Week',
    Day: 'Day',
    Hour: 'Hour',
};